import { Component , OnInit} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { NgwService } from '../../app/ngw.service';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable} from 'rxjs/Rx';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick } from '../../app/classes/NgwGame';
import { PlayerItem } from '../pages/players/playerItem';
import 'rxjs/add/operator/map';



@Component({
  selector: 'page-players',
  templateUrl: 'players.html'
})
export class PlayersPage implements OnInit {
  currGame = null;
   team:String = "away"
   selectedNgwPlayer:string = "Kevin";
   currPlayer:NgwPlayer = null;
   currRound:NgwRound = null;
  
 
  constructor(public navCtrl: NavController,  public http: Http, public ngwService: NgwService, public navParams: NavParams) {
    this.currPlayer = this.navParams.get('ngwPlayer');
     this.currRound = this.navParams.get('ngwRound');
  }

 ngOnInit(): void {
    this.currGame = this.ngwService.currentGame;

   
}

 isAlreadyPicked(player:any):Boolean 
    {
        if(this.currRound.picks.find((pick) => pick.nhlPlayer.person.id == player.person.id))
            return true;
        return false;
    }

    pickMade(event) {
      if(!this.isAlreadyPicked(event))
      {
     this.ngwService.makePick(this.currPlayer, this.currRound, event);
      this.navCtrl.pop();
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/players/players.ts